import { useRef } from 'react'
import type { CameraPlace } from '@v2/contracts'
import './camera-places.css'

/** SDK-authored destinations occupy one small control, regardless of game size. */
export function CameraPlaces({ places, onNavigate }: { places: readonly CameraPlace[]; onNavigate: (id: string) => void }) {
  const disclosure = useRef<HTMLDetailsElement>(null)
  if (!places.length) return null
  return <details className="tt-camera-places" ref={disclosure} onKeyDown={event => {
    if (event.key === 'Escape' && disclosure.current) { disclosure.current.open = false; disclosure.current.querySelector('summary')?.focus(); event.stopPropagation() }
  }}>
    <summary aria-label="Camera places" title="Game camera places">
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="m3 6 6-3 6 3 6-3v15l-6 3-6-3-6 3Z"/><path d="M9 3v15M15 6v15"/></svg>
    </summary>
    <div className="tt-camera-places-list" role="group" aria-label="Game camera places">
      {places.map(place => <button key={place.id} type="button" aria-label={`View ${place.label}`} onClick={() => {
        onNavigate(place.id)
        if (disclosure.current) { disclosure.current.open = false; disclosure.current.querySelector('summary')?.focus() }
      }}><span>{place.label}</span>{place.shortcut && <kbd title="When the table is focused">{place.shortcut}</kbd>}</button>)}
    </div>
  </details>
}
